import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby-interface"
import {
  SettingsCardContent,
  SettingsCardDescription,
} from "@modules/site/settings"
import { MdHelpOutline } from "react-icons/md"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"
import SiteSettingsSectionCard from "./SiteSettingsSectionCard"
import CopyUrl from "../../../ui/components/CopyUrl"
import {
  getBuildWebhookUrl,
  getPreviewWebhookUrl,
} from "@modules/site/shared/helpers"

const sharedContentCss = theme => ({
  maxWidth: "100%",
  marginTop: theme.space[5],
})

const HelpLink = styled(`a`)`
  display: flex;

  svg {
    fill: ${p => p.theme.colors.lilac};
    height: 1rem;
    margin-left: 0.375rem;
    width: 1rem;
  }
`

export default function WebhookSection({ siteId, type }) {
  const previewWebhookUrl = getPreviewWebhookUrl(siteId)
  const buildsWebhookUrl = getBuildWebhookUrl(siteId)

  return (
    <SiteSettingsSectionCard
      css={{ display: "block" }}
      id={
        type === SiteSettingsSection.BuildsWebhook
          ? SiteSettingsSection.BuildsWebhook
          : SiteSettingsSection.Webhook
      }
      renderTitle={defaultTitle => (
        <React.Fragment>
          {type === SiteSettingsSection.PreviewWebhook
            ? SiteSettingsSectionLabel[SiteSettingsSection.PreviewWebhook]
            : defaultTitle}
          {` `}
          <HelpLink
            target="_blank"
            href={`${window.location.origin}/docs/webhook/`}
            aria-label="Webhook docs"
          >
            <MdHelpOutline />
          </HelpLink>
        </React.Fragment>
      )}
    >
      {type === SiteSettingsSection.PreviewWebhook && (
        <SettingsCardContent css={sharedContentCss}>
          <SettingsCardDescription data-cy={`${type}-card-description`}>
            If a CMS is not available through our{` `}
            <Link
              href="https://support.gatsbyjs.com/hc/en-us/sections/360011112314-Connecting-to-a-Content-Management-System"
              target="_blank"
            >
              automated integrations,
            </Link>
            {` `}
            trigger preview updates by sending a POST request to this webhook
            URL whenever data is updated:
          </SettingsCardDescription>
          <CopyUrl url={previewWebhookUrl} data-cy-name={`${type}-url`} />
        </SettingsCardContent>
      )}
      {type === SiteSettingsSection.BuildsWebhook && (
        <SettingsCardContent css={sharedContentCss}>
          <SettingsCardDescription>
            If a CMS is not available through our{` `}
            <Link
              href="https://support.gatsbyjs.com/hc/en-us/sections/360011112314-Connecting-to-a-Content-Management-System"
              target="_blank"
            >
              automated integrations,
            </Link>
            {` `}
            trigger new builds whenever you publish content by sending a POST
            request to this webhook URL:
          </SettingsCardDescription>
          <CopyUrl url={buildsWebhookUrl} data-cy-name={`${type}-url`} />
        </SettingsCardContent>
      )}
    </SiteSettingsSectionCard>
  )
}
